import { UserToken, SET_TOKEN } from "types/actions/Token.actions";

const initState = { token: "" };

export default function authReducer(state = initState, action: UserToken) {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    default:
      return state;
  }
}
